import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { forkJoin, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { SelectedFiles } from "src/app/models/selected_files";
import { DocumentsService } from "src/app/services/documents.service";
import { environment } from "src/environments/environment";



import { AsyncPipe } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { FileSizePipe } from "../../pipe/filesize.pipe";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { ProgressBarModule } from "primeng/progressbar";
import { Ripple } from "primeng/ripple";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";

@Component({
    selector: "app-upload-files",
    templateUrl: "./upload-files.component.html",
    styleUrls: ["./upload-files.component.scss"],
    imports: [AsyncPipe, ButtonModule, FileSizePipe, FormsModule, InputTextModule, NgxPaginationModule, ProgressBarModule, Ripple, ToastModule, TooltipModule]
})
export class UploadFilesComponent implements OnInit {

  @Input() element:  any = [];

  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;
  blogForm: FormGroup;
  imageInfos?: Observable<any>;
  images: any;
  error: string;
  selectedFiles?: FileList;
  progressInfos: any[] = [];
  message: string[] = [];
  previews: string[] = [];
  uploadError: string;
  cols: any[];
  imagePath: any;
  filesPath = environment.files_url;
  selectedDocuments: any[] = [];
  documentPage = 1;

  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private documentService: DocumentsService,
  ) {}

  public ngOnInit(): void {
    const paramFiles = {
      page_id: this.element.id,
      limit: 100
    }


    this.imageInfos = this.documentService.list(paramFiles);

    
  }



  selectFiles(event: any): void {
    this.message = [];
    this.progressInfos = [];
    this.selectedFiles = event.target.files;

    this.previews = [];
    if (this.selectedFiles && this.selectedFiles[0]) {
      const numberOfFiles = this.selectedFiles.length;
      for (var i = 0; i < event.target.files.length; i++) {
        this.previews.push(event.target.files[i]);
        var files = [...this.previews];
      }
    }
  }

  onDeleteFile(image_id: any) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.documentService.delete_file(+image_id).subscribe(
          (res: any) => {
            if (res.status !== "success") {
              this.messageService.add({
                key: "myKeyUpload",
                severity: "error",
                summary: "Errore",
                detail: res.message || "Il documento non è stato cancellato",
              });
              return;
            }
            this.messageService.add({
              key: "myKeyUpload",
              severity: "success",
              summary: "Attenzione",
              detail: "Cancellazione avvenuta con successo",
            });
            
            // Refresh the file list
            this.refreshFiles();
          },
          (error) => {
            this.error = error;
            this.messageService.add({
              key: "myKeyUpload",
              severity: "error",
              summary: "Errore",
              detail: error?.error?.message || error?.message || "Si è verificato un errore durante la cancellazione",
            });
          }
        );
      },
    });
  }

  onDeleteSelectedFiles() {
    if (!this.selectedDocuments.length) return;

    this.confirmationService.confirm({
      message: `Sei sicuro di voler cancellare i ${this.selectedDocuments.length} documenti selezionati?`,
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const ids = this.selectedDocuments.map(document => +document.id);
        const deletions = ids.map(id => this.documentService.delete_file(id));

        forkJoin(deletions).subscribe({
          next: (responses: any[]) => {
            const failedResponse = responses.find(response => response.status !== "success");
            if (failedResponse) {
              this.messageService.add({
                key: "myKeyUpload",
                severity: "error",
                summary: "Errore",
                detail: failedResponse.message || "Uno o più documenti non sono stati cancellati",
              });
              this.selectedDocuments = [];
              this.refreshFiles();
              return;
            }
            this.messageService.add({
              key: "myKeyUpload",
              severity: "success",
              summary: "Attenzione",
              detail: "I documenti selezionati sono stati cancellati",
            });
            this.selectedDocuments = [];
            this.refreshFiles();
          },
          error: (error) => {
            this.error = error;
            this.messageService.add({
              key: "myKeyUpload",
              severity: "error",
              summary: "Errore",
              detail: error?.error?.message || error?.message || "Si è verificato un errore durante la cancellazione",
            });
            this.selectedDocuments = [];
            this.refreshFiles();
          },
        });
      },
    });
  }

  isSelected(file: any): boolean {
    return this.selectedDocuments.some(document => +document.id === +file.id);
  }

  toggleDocument(file: any, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedDocuments = checked
      ? [...this.selectedDocuments, file]
      : this.selectedDocuments.filter(document => +document.id !== +file.id);
  }

  areAllSelected(documents: any[]): boolean {
    return documents.length > 0 && documents.every(file => this.isSelected(file));
  }

  toggleAllDocuments(documents: any[], event: Event): void {
    this.selectedDocuments = (event.target as HTMLInputElement).checked ? [...documents] : [];
  }
  

  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };

    if (file) {
      const id = this.route.snapshot.paramMap.get("id");

      this.documentService.upload(file, this.element.id).subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event instanceof HttpResponse) {
            const msg = "Uploaded the file successfully: " + file.name;
            this.message.push(msg);
            this.refreshFiles();
            this.previews = [];
            this.progressInfos = [];
            setTimeout(() => {
              this.message = [];
            }, 1500);

          }
        },
        error: (err: any) => {
          this.progressInfos[idx].value = 0;
          const msg = "Could not upload the file: " + file.name;
          this.message.push(msg);
        },
      });
    }
    this.selectedFiles = null;
  }


  uploadFiles(): void {
    this.message = [];

    if (!this.selectedFiles) return;

    const files = Array.from(this.selectedFiles);
    this.progressInfos = files.map(file => ({ value: 0, fileName: file.name }));
    const uploads = files.map((file, idx) =>
      this.documentService.upload(file, this.element.id).pipe(
        tap((event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round((100 * event.loaded) / event.total);
          }
        })
      )
    );

    this.selectedFiles = null;
    forkJoin(uploads).subscribe({
      next: () => {
        this.message = files.map(file => "Uploaded the file successfully: " + file.name);
        this.previews = [];
        this.refreshFiles();
        setTimeout(() => this.message = [], 1500);
      },
      error: () => {
        this.message.push("One or more files could not be uploaded");
      },
    });
  }

  private refreshFiles(): void {
    this.documentPage = 1;
    this.imageInfos = this.documentService.list({ page_id: this.element.id, limit: 100 });
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("image").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath = reader.result;
      };
    }
  }

  removeImageFile() {
    this.imagePath = "";
    console.log(this.myInputVariable.nativeElement.files);
    this.myInputVariable.nativeElement.value = "";
    console.log(this.myInputVariable.nativeElement.files);
  }

  onRowEditSave(file: any) {

    const formData = new FormData();
    formData.append("description", file.description);
    formData.append("file_order", file.file_order);  

    
    const id = file.id;

      this.documentService.update(formData, +id).subscribe(
        (res) => {

          if (res.status == "error") {
            this.messageService.add({
              key: "myKey1",
              severity: "warn",
              summary: "Informazioni",
              detail: "Errore",
            });

            this.uploadError = res.message;
          } else {

            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Attenzione', detail: 'Salvato con sucesso' });
            this.refreshFiles();

          }
        },
        (error) => (this.error = error)
      );
    
  }

  onRowEditInit(image: any) {
    this.imageInfos[image.image_id] = { ...image };
  }


}
